/**
 * User Module
 */

import Axios from 'axios'
import { NOTY_TYPE } from '../../constant/builderConsts.js'
import LoadedDataValidity from '../../classes/LoadedDataValidity.js'
import dataExpirationTimes from '../../constant/dataExpirationTimes.js'

const userDataValidity = new LoadedDataValidity(dataExpirationTimes.TWO_MIN)
const couponFromPointDataValidity = new LoadedDataValidity(dataExpirationTimes.ONE_MIN)
const openOrdersDataValidity = new LoadedDataValidity(dataExpirationTimes.HALF_MIN)
const closedOrdersDataValidity = new LoadedDataValidity(dataExpirationTimes.HALF_MIN)
const returnClothingOrdersDataValidity = new LoadedDataValidity(dataExpirationTimes.HALF_MIN)
const readMessagesDataValidity = new LoadedDataValidity(dataExpirationTimes.ONE_MIN)
const unreadMessagesDataValidity = new LoadedDataValidity(dataExpirationTimes.ONE_MIN)
const answeredQuestionsDataValidity = new LoadedDataValidity(dataExpirationTimes.ONE_MIN)
const unansweredQuestionsDataValidity = new LoadedDataValidity(dataExpirationTimes.ONE_MIN)

const state = {
  /**
   * user adatok
   *
   * TODO: a api_profileSave végpont még használja a country-t, de ha ki élesedik a profile oldal, akkor ez a prop törölhető lesz
   *
   *  @type{
   *    {
   *      id: Number,
   *      username: String,
   *      fullName: String,
   *      email: String,
   *      avatarSrc: String,
   *      avatarLargeSrc: String,
   *      firstName: String,
   *      lastName: String,
   *      phone1: String,
   *      phone2: String,
   *      postAddress: String,
   *      zipCode: String,
   *      city: String,
   *      country: String,
   *      countryCode: String,
   *      gender: Number,
   *      birthDate: String,
   *      starCount: Number,
   *      vipPercent: Number,
   *      userPoint: Number,
   *      hasUserCoupons: Boolean,
   *      userCoupons: [{
   *        code: String,
   *        name: String,
   *      },],
   *      newsletterSubscribed: Boolean,
   *      pointPercent: Number,
   *      userPointInCurrency: String,
   *      giftPointPercent: Number,
   *      loyaltyPointDescription: String,
   *    }|null
   *  }
   */
  user: null,
  userInitDone: false,
  /**
   * user kedvencek
   *
   *  @type {
   *    {
   *      favoritesArticles: [{
   *        BID: Number,
   *        ID: Number,
   *        articleName: String,
   *        imageSrc: String,
   *        prologue: String,
   *        url: String,
   *      },],
   *      favoritesShopItems: [{
   *        BID: Number,
   *        GYARTO: Number,
   *        ID: Number,
   *        KISZERELES: String,
   *        brandName: String,
   *        isDiscounted: String,
   *        itemName: String,
   *        itemPrice: String,
   *        packaging: String,
   *        slug: String,
   *      },],
   *    }
   *  }
   */
  favorites: null,
  /**
   * hány db termék + cikk van a user kedvencei közt
   */
  favoritesCount: 0,
  /**
   * hány olvasatlan üzenete van a usernek
   */
  unreadMessagesCount: 0,
  /**
   * hány olvasott üzenete van a usernek
   */
  readMessagesCount: 0,
  /**
   * van-e belépett user
   *
   * @type Boolean
   */
  isUserLoggedIn: false,
  /**
   * myprofile oldalon utoljára kiválasztott tab indexe, hogy ha visszalépünk oda rakjon vissza
   */
  lastSelectedProfileTabIndex: 0,
  /**
   * nyitott rendelések
   * @typedef{
   *    {
   *      closeDate: String?,
   *      currency: String?
   *      id: String?
   *      isClosed: String?
   *      isPayed: String?
   *      orderDate: String?
   *      payDate: String?
   *      total: String?
   *      orderedItems: Array,
   *      coupon_code: String | null
   *    },[]
   * }
   */
  openOrders: null,
  /**
   * betöltődtek-e már a nyitott rendelések
   */
  isOpenOrdersLoaded: false,
  /**
   * zárt rendelések
   * @typedef{
   *    {
   *      closeDate: String?,
   *      currency: String?
   *      id: String?
   *      isClosed: String?
   *      isPayed: String?
   *      orderDate: String?
   *      payDate: String?
   *      total: String?
   *      orderedItems: Array,
   *      coupon_code: String | null
   *    },[]
   * }
   */
  closedOrders: null,
  /**
   * betöltődtek-e már a zárt rendelések
   */
  isClosedOrdersLoaded: false,
  /**
   * visszaküldhető ruházatot tartalmazó rendelések
   * @typedef{
   *    {
   *      closeDate: String?,
   *      currency: String?
   *      id: String?
   *      isClosed: String?
   *      isPayed: String?
   *      orderDate: String?
   *      payDate: String?
   *      total: String?
   *      orderedItems: Array,
   *      coupon_code: String | null
   *    },[]
   * }
   */
  returnClothinOrders: null,
  /**
   * betöltődtek-e már a visszaküldhető ruházatot tartalmazó rendelések
   */
  isReturnClothingOrdersLoaded: false,
  /**
   * olvasatlan üzenetek
   * @type [
   * {
   *    id: Number?,
   *    questionPosted: String?,
   *    answerPosted: String?,
   *    userId: Number?,
   *    email: String?,
   *    emailTo: String?,
   *    questionText: String?,
   *    answerText: String?,
   *    orderId: Number?,
   *    replyId: Number?,
   *    reply: String,
   *    replyText: Array,
   *    isMessageRead: Boolean?,
   *    isMessageOpen: Boolean?,
   *    orderMsg: [{
   *      id: Number,
   *      questionText: String,
   *      response: Boolean,
   *    }],
   *    lang: String  - pl.: 'hu',
   *    flagImgSrc: String,
   * }
   * ]
   */
  unreadMessages: null,
  /**
   * olvasott üzenetek
   * @type [{
   *    id: Number?,
   *    questionPosted: String?,
   *    answerPosted: String?,
   *    userId: Number?,
   *    email: String?,
   *    emailTo: String?,
   *    questionText: String?,
   *    answerText: String?,
   *    orderId: Number?,
   *    replyId: Number?,
   *    replyText: Array,
   *    isMessageRead: Boolean?,
   *    isMessageOpen: Boolean?,
   *    orderMsg: [{
   *      id: Number,
   *      questionText: String,
   *      response: Boolean,
   *    }],
   *    lang: String  - pl.: 'hu',
   *    flagImgSrc: String,
   * }]
   */
  readMessages: null,
  /**
   * betöltődtek-e már az olvasatlan üzenetek
   */
  isUnreadMessagesLoaded: false,
  /**
   * betöltődtek-e már az olvasott üzenetek
   */
  isReadMessagesLoaded: false,
  /**
   * töltődnek-e még a megválaszolatlan kérdések
   */
  isUnansweredQuestionsLoaded: false,
  /**
   * user megválaszolatlan kérdések
   * @type {[{
   *    id: Number?,
   *    questionDate: String?,
   *    answerDate: String?,
   *    answerText: String?,
   *    questionText: String?,
   *    productFormatted: Object?,
   * }]}
   */
  unansweredQuestions: [],
  /**
   * töltődnek-e még a megválaszolt kérdések
   */
  isAnsweredQuestionsLoaded: false,
  /**
   * user megválaszolt kérdések
   * @type {[{
   *    id: Number?,
   *    questionDate: String?,
   *    answerDate: String?,
   *    answerText: String?,
   *    questionText: String?,
   *    productFormatted: Object?,
   * }]}
   */
  answeredQuestions: [],
  /**
   * kupon generálása pontokbol adatok
   * @type {{
   *    availableBrands: [{
   *       id: Number?,
   *       logoSrc: String?,
   *       name: String?,
   *    }],
   *    availablePointLimits: [{
   *       pointLimit: Number?,
   *       details: {
   *         brandCount: Number?,
   *         brandIdList: Array?,
   *         noBrandCount: Number?,
   *       },
   *    }],
   *    noBrandCoupons: [{
   *       brandIds: Array?,
   *       domainIds: Array?,
   *       hasBrands: Boolean?,
   *       id: Number?,
   *       isAvailableOnDomain: Boolean?,
   *       name: String?,
   *       pointLimit: Number?,
   *       type: string?,
   *    }]
   *    brandCoupons: [{
   *       brandIds: Array?,
   *       domainIds: Array?,
   *       hasBrands: Boolean?,
   *       id: Number?,
   *       isAvailableOnDomain: Boolean?,
   *       name: String?,
   *       pointLimit: Number?,
   *       type: string?,
   *    }]
   *    hasCouponGenerateOptions: Boolean,
   * }}
   */
  couponFromPointData: null,
  /**
   * kupon generálása pontokbol adatok betöltődtek-e
   */
  isCouponFromPointDataLoaded: false,
  /**
   * folyamatban van-e kedvencekhez adás/törlés onnan
   */
  isFavoriteAddOrRemoveInProgress: false,
  /**
   * A domainhez tartozó logó elérése
   */
  domainLogo: null,
}

const getters = {
  /**
   * user getter
   *
   * @param state
   * @returns {null}
   */
  getUser: state => {
    return state.user
  },
  /**
   * user id getter
   *
   * @param state
   * @returns {null}
   */
  getUserId: state => {
    return state.user !== null ? state.user.id : null
  },
  /**
   * user kis avatar src getter
   *
   * @param state
   * @returns {null}
   */
  getUserAvatarSrc: state => {
    return state.user.avatarSrc
  },
  /**
   * user nagy avatar src getter
   *
   * @param state
   * @returns {null}
   */
  getUserAvatarLargeSrc: state => {
    return state.user.avatarLargeSrc
  },
  /**
   * user favorites getter
   *
   * @param state
   * @returns {
   *    {
   *      favoritesArticles: [{
   *        BID: Number,
   *        ID: Number,
   *        articleName: String,
   *        imageSrc: String,
   *        prologue: String,
   *        url: String,
   *      },],
   *      favoritesShopItems: [{
   *        BID: Number,
   *        GYARTO: Number,
   *        ID: Number,
   *        KISZERELES: String,
   *        brandName: String,
   *        isDiscounted: String,
   *        itemName: String,
   *        itemPrice: String,
   *        packaging: String,
   *        slug: String,
   *      },],
   *    }|null}
   */
  getFavorites: state => {
    return state.favorites
  },
  /**
   * user favorites count getter
   *
   * @param state
   * @returns {null}
   */
  getFavoritesCount: state => {
    return state.favoritesCount
  },
  /**
   * user olvasatlan üzenet count getter
   *
   * @param state
   * @returns {null}
   */
  getUnreadMessagesCount: state => {
    return state.unreadMessagesCount
  },
  /**
   * user olvasott üzenet count getter
   *
   * @param state
   * @returns {null}
   */
  getReadMessagesCount: state => {
    return state.readMessagesCount
  },
  /**
   * myprofile oldalon utoljára kiválasztott tab indexe, hogy ha visszalépünk oda rakjon vissza
   *
   * @param state
   * @returns {null}
   */
  getLastSelectedProfileTabIndex: state => {
    return state.lastSelectedProfileTabIndex
  },
  /**
   * be van-e jelentkezve user
   *
   * @param state
   * @returns {null}
   */
  isLoggedIn: state => {
    return state.isUserLoggedIn
  },
  /**
   * user fel van-e iratkozva hirlevélre
   *
   * @param state
   * @returns {Boolean}
   */
  isNewsLetterSubscribed: state => {
    return state.user.newsletterSubscribed
  },
  /**
   * user nyitott rendelések getter
   *
   * @param state
   * @returns {null}
   */
  getOpenOrders: state => {
    return state.openOrders
  },
  /**
   * Vissza adja az isOpenOrdersLoaded változót
   *
   * @returns {boolean}
   */
  getIsOpenOrdersLoaded: state => {
    return state.isOpenOrdersLoaded
  },
  /**
   * user zárt rendelések getter
   *
   * @param state
   * @returns {null}
   */
  getClosedOrders: state => {
    return state.closedOrders
  },
  /**
   * Vissza adja az isClosedOrdersLoaded változót
   *
   * @returns {boolean}
   */
  getIsClosedOrdersLoaded: state => {
    return state.isClosedOrdersLoaded
  },
  /**
   * user visszaküldhető ruházatot tartalmazó rendelések getter
   *
   * @param state
   * @returns {null}
   */
  getReturnClothingOrders: state => {
    return state.returnClothinOrders
  },
  /**
   * Vissza adja az isReturnClothingOrdersLoaded változót
   *
   * @returns {boolean}
   */
  getIsReturnClothingOrdersLoaded: state => {
    return state.isReturnClothingOrdersLoaded
  },
  /**
   * olvasott üzenet getter
   *
   * @param state
   * @returns {null}
   */
  getReadMessages: state => {
    return state.readMessages
  },
  /**
   * olvasatlan üzenet getter
   *
   * @param state
   * @returns {null}
   */
  getUnreadMessages: state => {
    return state.unreadMessages
  },
  /**
   * Vissza adja, hogy betöltődtek-e az olvasatlan üzenetek
   * @param state
   * @returns {boolean}
   */
  getIsUnreadMessagesLoaded: state => {
    return state.isUnreadMessagesLoaded
  },
  /**
   * Vissza adja, hogy betöltődtek-e az olvasott üzenetek
   * @param state
   * @returns {boolean}
   */
  getIsReadedMessagesLoaded: state => {
    return state.isReadMessagesLoaded
  },
  /**
   * megválaszolatlan kérdések getter
   *
   * @param state
   * @returns {null}
   */
  getUnansweredQuestions: state => {
    return state.unansweredQuestions
  },
  /**
   * megválaszolt kérdések getter
   *
   * @param state
   * @returns {null}
   */
  getAnsweredQuestions: state => {
    return state.answeredQuestions
  },
  /**
   * Betöltöttek a megválaszoltalan kérdések
   *
   * @param state
   * @returns {boolean}
   */
  getIsUnansweredQuestionsLoaded: state => {
    return state.isUnansweredQuestionsLoaded
  },
  /**
   * Betöltöttek a megválaszolt kérdések
   *
   * @param state
   * @returns {boolean}
   */
  getisAnsweredQuestionsLoaded: state => {
    return state.isAnsweredQuestionsLoaded
  },
  /**
   * kupon generálása pontokbol adatok getter
   *
   * @param state
   * @returns {null}
   */
  getCouponFromPointData: state => {
    return state.couponFromPointData
  },
  /**
   * kupon generálása pontokbol adatok betöltődtek-e
   *
   * @param state
   * @returns {null}
   */
  getIsCouponFromPointDataLoaded: state => {
    return state.isCouponFromPointDataLoaded
  },
  /**
   * folyamatban van-e kedvencekhez adás/törlés onnan
   *
   * @param state
   * @returns {null}
   */
  getIsFavoriteAddOrRemoveInProgress: state => {
    return state.isFavoriteAddOrRemoveInProgress
  },
}

const actions = {
  init({ dispatch }) {
    return Promise.all([
      dispatch('getActiveUser'),
    ])
  },
  /**
   * user data frissités amikor kell, de csak azt
   *
   * @param commit
   * @return {Promise<AxiosResponse<any>>}
   */
  loadUserData({ commit }) {
    return Axios.get('User/api/loadUserData')
      .then(({ data }) => {
        if (data.isLoggedIn) {
          commit('setUser', data.user)
          commit('setIsUserLoggedIn', true)
        } else {
          commit('setUser', null)
          commit('setIsUserLoggedIn', false)
        }
      })
      .catch((error) => {
        commit('setUser', null)
        commit('setIsUserLoggedIn', false)
        console.error(error)
      })
  },
  afterLoginOrLogout({ dispatch, commit }) {
    commit('setUserInitDone', false)
    commit('setUser', null)
    commit('setFavorites', null)
    commit('setFavoritesCount', 0)
    commit('setIsUserLoggedIn', false)
    commit('setUnreadMessagesCount', 0)
    commit('setReadMessagesCount', 0)
    commit('setLastSelectedProfileTabIndex', 0)
    commit('setOpenOrders', null)
    commit('setIsOpenOrdersLoaded', false)
    commit('setClosedOrders', null)
    commit('setIsClosedOrdersLoaded', false)
    commit('setReturnClothing', null)
    commit('setIsReturnClothingOrdersLoaded', false)
    commit('setUnreadMessages', null)
    commit('setReadMessages', null)
    commit('setIsUnreadMessagesLoaded', false)
    commit('setIsReadMessagesLoaded', false)
    commit('setIsUnansweredQuestionsLoaded', false)
    commit('setIsAnsweredQuestionsLoaded', false)
    commit('setUnansweredQuestions', [])
    commit('setAnsweredQuestions', [])
    commit('setCouponFromPointData', null)
    commit('setIsCouponFromPointDataLoaded', false)
    return Promise.all([
      dispatch('getActiveUser'),
    ])
  },
  addItemToFavorites() {

  },
  /**
   * user logout
   *
   * @return {Promise<AxiosResponse<any>>}
   */
  logout() {
    return Axios.post('/User/api/userLogout', function () {
    })
  },
  /**
   * loaded active user invalidálása és lekérése
   *
   * @return {Promise<void>|*}
   */
  refreshActiveUser({ dispatch }) {
    userDataValidity.resetDateToInspect()
    return dispatch('getActiveUser')
  },
  // TODO: ha kiment a #911 akkor a login, logout is innen menjen...
  /**
   * jelenleg bejelentkezett user-t kérjük le, ha van
   *
   * @param commit
   */
  getActiveUser({ commit }) {
    if ((state.user !== null || state.userInitDone) && userDataValidity.isUpToDate()) {
      return Promise.resolve()
    }
    return Axios.get('User/api/getActiveUser')
      .then(({ data }) => {
        if (data.isLoggedIn) {
          commit('setUser', data.user)
          commit('setFavorites', data.favorites)
          commit('setFavoritesCount', data.favoritesCount)
          commit('setUnreadMessagesCount', data.unreadMessagesCount)
          commit('setReadMessagesCount', data.readMessagesCount)
          commit('setIsUserLoggedIn', true)
          window.setActiveUser(data.user)
        } else {
          commit('setUser', null)
          commit('setFavorites', null)
          commit('setFavoritesCount', 0)
          commit('setIsUserLoggedIn', false)
        }
        userDataValidity.setDateToInspect()
      })
      .catch((error) => {
        userDataValidity.resetDateToInspect()
        commit('setUser', null)
        commit('setFavorites', null)
        commit('setFavoritesCount', 0)
        commit('setIsUserLoggedIn', false)
        console.error(error)
      })
      .finally(() => {
        commit('setUserInitDone', true)
      })
  },
  /**
   * kupon generáláshoz szükséges adatok betöltése
   *
   * @param commit
   * @return {Promise<unknown>|Promise<void>}
   */
  loadCouponFromPointData({ commit }) {
    if (state.isCouponFromPointDataLoaded && couponFromPointDataValidity.isUpToDate()) {
      return Promise.resolve()
    }
    return Axios.get('User/api/getCouponFromPointsData')
      .then(({ data }) => {
        commit('setCouponFromPointData', data)
        couponFromPointDataValidity.setDateToInspect()
      })
      .catch((e) => {
        couponFromPointDataValidity.resetDateToInspect()
        console.error('getCouponFromPointsData', e)
        this.$root.$emit('notificationPush', this.$t('sikertelen_muvelet'), NOTY_TYPE.NOTY_ERROR)
      })
      .finally(() => {
        commit('setIsCouponFromPointDataLoaded', true)
      })
  },
  /**
   * friss avatar src-k lekérése
   *
   * @return {Promise<AxiosResponse<any>>}
   */
  refreshAvatarSrc() {
    return Axios.get('User/api/refreshAvatarSrc')
      .then(({ data }) => {
        state.user.avatarSrc = data.avatarSrc
        state.user.avatarLargeSrc = data.avatarLargeSrc
      })
      .catch((e) => {
        console.error('refreshAvatarSrc', e)
        this.$root.$emit('notificationPush', this.$t('sikertelen_muvelet'), NOTY_TYPE.NOTY_ERROR)
      })
  },
  /**
   * nyitott rendelések lekérése
   *
   * @param commit
   * @return {Promise<unknown>|Promise<void>}
   */
  getOpenOrders({ commit }) {
    // ha akarjuk, hogy csak 1x töltse be
    if (state.isOpenOrdersLoaded && openOrdersDataValidity.isUpToDate()) {
      return Promise.resolve()
    }
    return Axios.get('User/api/getOpenOrders')
      .then(({ data }) => {
        commit('setOpenOrders', data)
        openOrdersDataValidity.setDateToInspect()
      })
      .catch((e) => {
        openOrdersDataValidity.resetDateToInspect()
        console.error('getOpenOrders', e)
        this.$root.$emit('notificationPush', this.$t('sikertelen_muvelet'), NOTY_TYPE.NOTY_ERROR)
      })
      .finally(() => {
        commit('setIsOpenOrdersLoaded', true)
      })
  },
  /**
   * zárt rendelések lekérése
   *
   * @param commit
   * @return {Promise<unknown>|Promise<void>}
   */
  getClosedOrders({ commit }) {
    // ha akarjuk, hogy csak 1x töltse be
    if (state.isClosedOrdersLoaded && closedOrdersDataValidity.isUpToDate()) {
      return Promise.resolve()
    }
    return Axios.get('User/api/getClosedOrders')
      .then(({ data }) => {
        commit('setClosedOrders', data)
        closedOrdersDataValidity.setDateToInspect()
      })
      .catch((e) => {
        closedOrdersDataValidity.resetDateToInspect()
        console.error('getClosedOrders', e)
        this.$root.$emit('notificationPush', this.$t('sikertelen_muvelet'), NOTY_TYPE.NOTY_ERROR)
      })
      .finally(() => {
        commit('setIsClosedOrdersLoaded', true)
      })
  },
  /**
   * Olyan rendelések lekérdezése, ami tartalmaz visszaküldhető ruházatot
   *
   * @param commit
   * @returns {Promise<void>}
   */
  getReturnClothingOrders({ commit }) {
    // ha akarjuk, hogy csak 1x töltse be
    if (state.isReturnClothingOrdersLoaded && returnClothingOrdersDataValidity.isUpToDate()) {
      return Promise.resolve()
    }
    return Axios.get('User/api/getReturnClothingOrders')
        .then(({ data }) => {
          commit('setReturnClothingOrders', data)
          returnClothingOrdersDataValidity.setDateToInspect()
        })
        .catch((e) => {
          returnClothingOrdersDataValidity.resetDateToInspect()
          console.error('getReturnClothingOrders', e)
          this.$root.$emit('notificationPush', this.$t('sikertelen_muvelet'), NOTY_TYPE.NOTY_ERROR)
        })
        .finally(() => {
          commit('setIsReturnClothingOrdersLoaded', true)
        })
  },
  /**
   * user üzenet lekérése (olvasott/olvasatlan)
   *
   * @param commit
   * @param showReadMessages
   * @return {Promise<unknown>|Promise<void>}
   */
  getMessages({ commit }, showReadMessages) {
    // ha akarjuk, hogy csak 1x töltse be
    if (showReadMessages && state.isReadMessagesLoaded && readMessagesDataValidity.isUpToDate()) {
      return Promise.resolve()
    } else if (!showReadMessages && state.isUnreadMessagesLoaded && unreadMessagesDataValidity.isUpToDate()) {
      return Promise.resolve()
    }
    return Axios.get('User/api/getMessages', {
      params: {
        showReadMessages: showReadMessages,
      },
    })
      .then(({ data }) => {
        if (showReadMessages) {
          commit('setReadMessages', data)
          readMessagesDataValidity.setDateToInspect()
        } else {
          commit('setUnreadMessages', data)
          unreadMessagesDataValidity.setDateToInspect()
        }
      })
      .catch((e) => {
        if (showReadMessages) {
          readMessagesDataValidity.resetDateToInspect()
        } else {
          unreadMessagesDataValidity.resetDateToInspect()
        }
        console.error('getMessages', e)
        this.$root.$emit('notificationPush', this.$t('sikertelen_muvelet'), NOTY_TYPE.NOTY_ERROR)
      })
      .finally(() => {
        if (showReadMessages) {
          commit('setIsReadMessagesLoaded', true)
        } else {
          commit('setIsUnreadMessagesLoaded', true)
        }
      })
  },
  /**
   * user kérdések lekérése (megválaszolt/megválaszolatlan)
   *
   * @param commit
   * @param showAnsweredQuestions
   * @return {Promise<unknown>|Promise<void>}
   */
  getQuestions({ commit }, showAnsweredQuestions) {
    // ha akarjuk, hogy csak 1x töltse be
    if (showAnsweredQuestions && state.isAnsweredQuestionsLoaded && answeredQuestionsDataValidity.isUpToDate()) {
      return Promise.resolve()
    } else if (!showAnsweredQuestions && state.isUnansweredQuestionsLoaded && unansweredQuestionsDataValidity.isUpToDate()) {
      return Promise.resolve()
    }
    return Axios.get('User/api/getUsersQuestions', {
      params: {
        showAnsweredQuestions: showAnsweredQuestions,
      },
    })
      .then(({ data }) => {
        if (showAnsweredQuestions) {
          commit('setAnsweredQuestions', data)
          answeredQuestionsDataValidity.setDateToInspect()
        } else {
          commit('setUnansweredQuestions', data)
          unansweredQuestionsDataValidity.setDateToInspect()
        }
      })
      .catch((e) => {
        if (showAnsweredQuestions) {
          answeredQuestionsDataValidity.resetDateToInspect()
        } else {
          unansweredQuestionsDataValidity.resetDateToInspect()
        }
        console.error('getMessages', e)
        this.$root.$emit('notificationPush', this.$t('sikertelen_muvelet'), NOTY_TYPE.NOTY_ERROR)
      })
      .finally(() => {
        if (showAnsweredQuestions) {
          commit('setIsAnsweredQuestionsLoaded', true)
        } else {
          commit('setIsUnansweredQuestionsLoaded', true)
        }
      })
  },
  /**
   * user kedvenc törlése
   */
  removeFavorite({ dispatch, commit }, payload) {
    commit('setIsFavoriteAddOrRemoveInProgress', true)
    return Axios.post('/User/api/removeFromFavorites', {
      bookmarkId: payload.bookmarkId,
    })
      .then(() => {
        switch (payload.type) {
          case 'shop_item':
            const toDeleteItemIndex = state.favorites.favoritesShopItems.findIndex(shopItem => shopItem.ID === payload.product_id)
            if (toDeleteItemIndex !== -1) {
              state.favorites.favoritesShopItems.splice(toDeleteItemIndex, 1)
            }
            break
          case 'article':
            const toDeleteArticleIndex = state.favorites.favoritesArticles.findIndex(shopItem => shopItem.ID === payload.product_id)
            if (toDeleteArticleIndex !== -1) {
              state.favorites.favoritesArticles.splice(toDeleteArticleIndex, 1)
            }
            break
        }
        commit('setFavoritesCount', state.favoritesCount - 1)
      })
      .catch((error) => {
        console.error(error)
      })
      .finally(() => {
        dispatch('loadUserFavorites')
        commit('setIsFavoriteAddOrRemoveInProgress', false)
      })
  },
  /**
   * user kedvenc hozzáadása
   */
  addToFavorites({ dispatch, commit }, payload) {
    commit('setIsFavoriteAddOrRemoveInProgress', true)
    return Axios.post('/User/api/addToFavorite', {
      product_id: payload.product_id,
      type: payload.type,
    })
      .then(() => {
        dispatch('loadUserFavorites')
      })
      .catch((error) => {
        console.error(error)
      })
      .finally(() => {
        commit('setIsFavoriteAddOrRemoveInProgress', false)
      })
  },
  /**
   * user favorites frissitése
   *
   * @return {Promise<AxiosResponse<any>>}
   */
  loadUserFavorites({ commit }) {
    return Axios.get('/User/api/getUserFavorites')
      .then(({ data }) => {
        commit('setFavorites', data.favorites)
        commit('setFavoritesCount', data.favoritesCount)
      })
      .catch((error) => {
        console.error(error)
      })
  },
  /**
   * kupon generálás után csak ezt a pár adatot szeretnénk uj lekérni
   *
   * @return {Promise<AxiosResponse<any>>}
   */
  getFreshDataAfterCouponGenerate() {
    return Axios.get('User/api/getFreshDataAfterCouponGenerate')
      .then(({ data }) => {
        state.user.userPoint = data.userPoint
        state.user.hasUserCoupons = data.hasUserCoupons
        state.user.userCoupons = data.userCoupons
        state.user.userPointInCurrency = data.userPointInCurrency
      })
      .catch((e) => {
        console.error('getFreshDataAfterCouponGenerate', e)
      })
  },
  /**
   * user hirlevél feliratkozott-e beállitás
   *
   * @param isSubscribed
   */
  setMailSubscription({}, isSubscribed) {
    state.user.newsletterSubscribed = isSubscribed
  },
  /**
   * user olvasatlan üzenetek counter frissitése
   *
   * @param commit
   */
  refreshUnreadMessageCount({ commit }) {
    Axios.get('User/api/refreshUnreadMessagesCount')
      .then(({ data }) => {
        commit('setUnreadMessagesCount', data.unreadMessagesCount)
      })
      .catch((e) => {
        console.error('refreshUnreadMessageCount', e)
      })
  },
  /**
   * user olvasott üzenetek counter frissitése
   *
   * @param commit
   */
  refreshReadMessageCount({ commit }) {
    Axios.get('User/api/refreshReadMessagesCount')
      .then(({ data }) => {
        commit('setReadMessagesCount', data.readMessagesCount)
      })
      .catch((e) => {
        console.error('refreshReadMessageCount', e)
      })
  },
  /**
   * profil tab választáskor utoljára használt tab indexének mentése, hogy vissza tudjunk lépni oda
   *
   * @param commit
   * @param tabIndex
   */
  updateLastSelectedTab({ commit }, tabIndex) {
    commit('setLastSelectedProfileTabIndex', tabIndex)
  },
}

const mutations = {
  /**
   * @param state
   * @param payload
   */
  setUser(state, payload) {
    state.user = payload
  },
  /**
   * @param state
   * @param payload
   */
  setUserInitDone(state, payload) {
    state.userInitDone = payload
  },
  /**
   * @param state
   * @param payload
   */
  setIsUserLoggedIn(state, payload) {
    state.isUserLoggedIn = payload
  },
  /**
   * @param state
   * @param payload
   */
  setFavorites(state, payload) {
    state.favorites = payload
  },
  /**
   * @param state
   * @param payload
   */
  setFavoritesCount(state, payload) {
    state.favoritesCount = payload
  },
  /**
   * @param state
   * @param payload
   */
  setUnreadMessagesCount(state, payload) {
    state.unreadMessagesCount = payload
  },
  /**
   * @param state
   * @param payload
   */
  setReadMessagesCount(state, payload) {
    state.readMessagesCount = payload
  },
  /**
   * @param state
   * @param payload
   */
  setLastSelectedProfileTabIndex(state, payload) {
    state.lastSelectedProfileTabIndex = payload
  },
  /**
   * @param state
   * @param payload
   */
  setOpenOrders(state, payload) {
    state.openOrders = payload
  },
  /**
   * @param state
   * @param payload
   */
  setIsOpenOrdersLoaded(state, payload) {
    state.isOpenOrdersLoaded = payload
  },
  /**
   * @param state
   * @param payload
   */
  setClosedOrders(state, payload) {
    state.closedOrders = payload
  },
  /**
   * @param state
   * @param payload
   */
  setIsClosedOrdersLoaded(state, payload) {
    state.isClosedOrdersLoaded = payload
  },
  /**
   * @param state
   * @param payload
   */
  setReturnClothingOrders(state, payload) {
    state.returnClothinOrders = payload
  },
  /**
   * @param state
   * @param payload
   */
  setIsReturnClothingOrdersLoaded(state, payload) {
    state.isReturnClothingOrdersLoaded = payload
  },
  /**
   * @param state
   * @param payload
   */
  setUnreadMessages(state, payload) {
    state.unreadMessages = payload
  },
  /**
   * @param state
   * @param payload
   */
  setIsUnreadMessagesLoaded(state, payload) {
    state.isUnreadMessagesLoaded = payload
  },
  /**
   * @param state
   * @param payload
   */
  setReadMessages(state, payload) {
    state.readMessages = payload
  },
  /**
   * @param state
   * @param payload
   */
  setIsReadMessagesLoaded(state, payload) {
    state.isReadMessagesLoaded = payload
  },
  /**
   * @param state
   * @param payload
   */
  setUnansweredQuestions(state, payload) {
    state.unansweredQuestions = payload
  },
  /**
   * @param state
   * @param payload
   */
  setIsUnansweredQuestionsLoaded(state, payload) {
    state.isUnansweredQuestionsLoaded = payload
  },
  /**
   * @param state
   * @param payload
   */
  setAnsweredQuestions(state, payload) {
    state.answeredQuestions = payload
  },
  /**
   * @param state
   * @param payload
   */
  setIsAnsweredQuestionsLoaded(state, payload) {
    state.isAnsweredQuestionsLoaded = payload
  },
  /**
   * @param state
   * @param payload
   */
  setCouponFromPointData(state, payload) {
    state.couponFromPointData = payload
  },
  /**
   * @param state
   * @param payload
   */
  setIsCouponFromPointDataLoaded(state, payload) {
    state.isCouponFromPointDataLoaded = payload
  },
  /**
   * @param state
   * @param payload
   */
  setIsFavoriteAddOrRemoveInProgress(state, payload) {
    state.isFavoriteAddOrRemoveInProgress = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
